// Renders an admin proxy response generically: an array of objects as a
// table (columns = the union of keys seen), anything else as formatted
// JSON. Compute/Policy admin shapes (08-contracts.md #3, Phase 7) are
// intentionally not modeled 1:1 in the UI's type layer -- these are
// read-only diagnostic views, and a generic renderer stays correct as
// those shapes evolve rather than silently dropping new fields.
//
// It prints every key it is given, which is the point and also the
// hazard: do not point this at a struct that carries credentials. The
// fleet board does not (api/admin.ts ComputeUnitRaw names only the safe
// fields, deliberately); what is left here is assignments, leases, stats,
// deployments and KillSwitch's live-resource view, none of which carry a
// worker token.
export default function JsonTable({ data }: { data: unknown }) {
  if (data === undefined || data === null) return <p className="a-empty">—</p>;
  if (Array.isArray(data)) {
    if (data.length === 0) return <p className="a-empty">none</p>;
    if (data.every((row) => row && typeof row === "object" && !Array.isArray(row))) {
      const columns = Array.from(new Set(data.flatMap((row) => Object.keys(row as object))));
      return (
        <div className="a-scroll">
          <table className="a-table">
            <thead>
              <tr>
                {columns.map((c) => (
                  <th key={c}>{c}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, i) => (
                <tr key={i}>
                  {columns.map((c) => (
                    <td key={c}>{formatCell((row as Record<string, unknown>)[c])}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
  }
  return <pre className="a-json">{JSON.stringify(data, null, 2)}</pre>;
}

function formatCell(v: unknown): string {
  if (v === undefined || v === null) return "—";
  if (typeof v === "object") return JSON.stringify(v);
  return String(v);
}
